export enum HostType {
  'VMWare' = 'VMWare',
  'HyperV' = 'HyperV',
  'Proxmox' = 'Proxmox'
}

export enum HostTypeNumbers {
  'VMWare' = 0,
  'HyperV' = 1,
  'Proxmox' = 2
}

/**
 * @interface SelectHostStepValue - interface for select host step
 * @property {Boolean} remember - is remember password (need correctly comment text)
 */
export interface SelectHostStepValue {
  server: string;
  login: string;
  password: string;
  remember?: boolean;
  host?: string;
  valid?: boolean;
}
